export default __webpack_public_path__ + "static/media/Img_CalSimulation.a51a283b.jpg";